import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import {
    SettingsModule as SharedSettingsModule,
    ArmyBuilderSharedModule,
    SettingsSyncService,
    EntityPreloadModule,
    CustomLoader,
    PageLayoutModule,
    DebugPanelModule
} from 'army-builder-shared';
import { TranslateModule } from '@ngx-translate/core';
import { NgLetModule } from 'ng-let';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SubscriptionModule } from '../subscription/subscription.module';

import { UserPage } from './user/user.page';
import { SubscriptionSettingsPage } from './subscription-settings.page';
import { SettingsShellComponent } from './shell/settings-shell.component';
import { SettingsMenuComponent } from './menu/settings-menu.component';
import { AccountSettingsPage } from './account/account-settings.page';
import { DevicesSettingsPage } from './devices/devices-settings.page';
import { AccountActionsPage } from './actions/account-actions.page';
import { SocialSigninService } from './user/service/social-signin.service';

@NgModule({
    declarations: [
        UserPage,
        SubscriptionSettingsPage,
        SettingsShellComponent,
        SettingsMenuComponent,
        AccountSettingsPage,
        DevicesSettingsPage,
        AccountActionsPage
    ],
    imports: [
        CommonModule,
        IonicModule,
        PageLayoutModule,
        RouterModule,
        SharedSettingsModule,
        ArmyBuilderSharedModule,
        NgLetModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SubscriptionModule,
        EntityPreloadModule,
        DebugPanelModule
    ],
    providers: [InAppBrowser, SocialSigninService],
    exports: []
})
export class WarlordSettingsModule {
    constructor(_settingsSyncService: SettingsSyncService) {}
}
